var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-select',{staticClass:"CoinSelect",attrs:{"errorHave":false,"value":_vm.myValue,"options":_vm.options,"filterable":true,"newStyleFormat":"","fill":""},on:{"onChanges":_vm.selectLineChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }